import {
  ApprovalsMaterializedApprovalFlowHistoryDocument,
  BulkApproveMaterializedApprovalsFlowDocument,
  BulkApproveMaterializedApprovalsFlowMutationVariables,
  BulkRejectMaterializedApprovalsFlowDocument,
  BulkRejectMaterializedApprovalsFlowMutationVariables,
  GetMaterializedApprovalsFlowsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useMaterializedApprovalFlowHistory = (resourceId: number, resourceType: string) => {
  const { data, loading } = useQuery(ApprovalsMaterializedApprovalFlowHistoryDocument, {
    variables: { resourceType, resourceIds: [resourceId] },
    fetchPolicy: 'network-only',
  })

  const materializedApprovalFlow = data?.approvals.materializedApprovalsFlowsConnection.nodes[0]

  return {
    loading,
    materializedApprovalFlow,
  }
}
export const useBulkApproveMaterializedApprovalFlow = () => {
  const [bulkApproveFlow, { loading }] = useMutation(BulkApproveMaterializedApprovalsFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.bulkApproveApprovalsMaterializedApprovalsFlow,
  })

  return {
    loading,
    bulkApproveMaterializedFlow(
      variables: BulkApproveMaterializedApprovalsFlowMutationVariables,
      companyId: number
    ) {
      return bulkApproveFlow({
        variables,
        refetchQueries: [
          {
            query: GetMaterializedApprovalsFlowsDocument,
            variables: {
              ids: variables.materializedApprovalFlowIds,
              companyId,
            },
          },
        ],
      })
    },
  }
}

export const useBulkRejectMaterializedApprovalFlow = () => {
  const [bulkRejectFlow, { loading }] = useMutation(BulkRejectMaterializedApprovalsFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.bulkRejectApprovalsMaterializedApprovalsFlow,
  })

  return {
    loading,
    bulkRejectMaterializedFlow(
      variables: BulkRejectMaterializedApprovalsFlowMutationVariables,
      companyId: number
    ) {
      return bulkRejectFlow({
        variables,
        refetchQueries: [
          {
            query: GetMaterializedApprovalsFlowsDocument,
            variables: {
              ids: variables.materializedApprovalFlowIds,
              companyId,
            },
          },
        ],
      })
    },
  }
}
